import { FormikProps } from "formik";
import CustomInput from "../../../components/common/Inputs/CustomInput";
import SelectInput, {
  OptionType,
} from "../../../components/common/Inputs/SelectInput";
import { UserInterface } from "../../../interfaces/userInterface";
import ChangePassword from "./ChangePassword";

type UserFormProps = {
  formik: FormikProps<UserInterface>;
  rolesOptions: OptionType[];
};

export const UserForm = (props: UserFormProps) => {
  const { formik, rolesOptions } = props;
  const isEditing = !!formik.values._id;

  const passwordError =
    formik.touched.password &&
    formik.errors.password &&
    Array.isArray(formik.errors.password)
      ? formik.errors.password.join(", ")
      : formik.errors.password;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <CustomInput
        label="Nombre"
        error={
          formik.touched.name &&
          formik.errors.name &&
          Array.isArray(formik.errors.name)
            ? formik.errors.name.join(", ")
            : formik.errors.name
        }
        {...formik.getFieldProps("name")}
        onChange={(e) => {
          formik.handleChange(e);
        }}
      />
      <CustomInput
        label="Apellidos"
        error={
          formik.touched.lastName &&
          formik.errors.lastName &&
          Array.isArray(formik.errors.lastName)
            ? formik.errors.lastName.join(", ")
            : formik.errors.lastName
        }
        {...formik.getFieldProps("lastName")}
        onChange={(e) => {
          formik.handleChange(e);
        }}
      />
      <CustomInput
        label="Nombre de Usuario"
        error={
          formik.touched.userName &&
          formik.errors.userName &&
          Array.isArray(formik.errors.userName)
            ? formik.errors.userName.join(", ")
            : formik.errors.userName
        }
        {...formik.getFieldProps("userName")}
        onChange={(e) => {
          formik.handleChange(e);
        }}
      />
      {isEditing ? (
        <ChangePassword
          error={passwordError}
          {...formik.getFieldProps("password")}
          onChange={(e) => {
            formik.handleChange(e);
          }}
          formik={formik}
          oldPassword={formik.initialValues.password}
        />
      ) : (
        <CustomInput
          label="Contraseña"
          type="password"
          error={passwordError}
          {...formik.getFieldProps("password")}
          onChange={(e) => {
            formik.handleChange(e);
          }}
        />
      )}
      <SelectInput
        label="Roles"
        options={rolesOptions}
        error={
          formik.touched.roleId &&
          formik.errors.roleId &&
          Array.isArray(formik.errors.roleId)
            ? formik.errors.roleId.join(", ")
            : formik.errors.roleId
        }
        {...formik.getFieldProps("roleId")}
        onChange={(e) => {
          formik.handleChange(e);
        }}
      />
    </div>
  );
};
